import * as React from "react";
import i18n from "i18next";
import {Dropdown, DropdownItemProps, Icon, LabelProps, Menu, Sidebar} from 'semantic-ui-react';

import Button from "../../../components/Button";
import {EOptionState} from "../../../components/DerivateOptionBar";
import {DerivateUtils, DerivateAssignmentFilterTypesSpecificMarket} from "../../../components/Table/components/derivate/DerivateUtils";
import {PropertiesKey, SpecificFilterEnum} from "../OptionsViewUtils";
import {IOptionsHeaderProps, IOptionsHeaderState} from "./IOptionsHeader";
import StandardModeHeader from "../../../components/Table/components/headerComponents/StandardModeHeader";
import AdvancedModeHeader from "../../../components/Table/components/headerComponents/AdvancedModeHeader";

const SelectAllAssignmentTypes = -1;
const SelectOnlyMissingPDiPAssignments = -2;
const SelectEmptyAssignmentTypes = -3;

export default class OptionsHeader extends React.Component<IOptionsHeaderProps, IOptionsHeaderState> {
    constructor(props: IOptionsHeaderProps) {
        super(props);

        this.state = {
            isSpecificFilterVisible: false,
            isAssignmentFilterVisible: false,
        };
    }

    componentDidUpdate(prevProps: Readonly<IOptionsHeaderProps>, prevState: Readonly<IOptionsHeaderState>, snapshot?: any): void {
        if (this.props.loadedPSL !== prevProps.loadedPSL) {
            this.setState({
                isSpecificFilterVisible: false,
                isAssignmentFilterVisible: false,
            });
        }
    }

    private getSpecificFilterDataSource = () => ([
        {
            text: i18n.t('SM_OPTIONS_VIEW:SHOW_ALL'),
            value: SpecificFilterEnum.SHOW_ALL,
            className: "font-weight--bold"
        },
        {
            text: i18n.t('SM_OPTIONS_VIEW:SHOW_PDIP_OPTIONS'),
            value: SpecificFilterEnum.SHOW_PDIP_OPTIONS,
            className: "font-weight--bold"
        },
        {
            text: i18n.t('SM_OPTIONS_VIEW:SHOW_BM_OPTIONS'),
            value: SpecificFilterEnum.SHOW_BM_OPTIONS,
            className: "font-weight--bold"
        },
        {
            text: i18n.t('SM_OPTIONS_VIEW:SHOW_PDIP_SYNC_ERROR_OPTIONS'),
            value: SpecificFilterEnum.SHOW_PDIP_SYNC_ERROR_OPTIONS,
            className: "font-weight--bold pdip-sync-error-option-color"
        }
    ])

    private renderAssignmentFilterLabel = (item: DropdownItemProps, index: number, label: LabelProps) => ({
        content: (
            <div
                className={`display--contents
                ${this.props.assignmentTypeFilterValue.filterValues.size > 7 ? 'font-size--smaller' : ''}
                ${item.value === SelectOnlyMissingPDiPAssignments ? item.className : ''}`}
            >
                {item.icon}<sup className={"font-weight--bold"}>{item.supIconValue}</sup>{!item.icon && item.text}
            </div>
        )
    })

    /**
     * Get valid filter assignment types based on loaded PSL.
     * Specific market PSLs contain PDiP assignment types.
     */
    private getLoadedPSLValidAssignmentTypes = () => {
        return this.props.loadedPSL ?
            // this.props.loadedPSL.cnr.cnr === PropertiesKey.BasicMarketCnrKey ? DerivateAssignmentFilterTypesBasicMarket : DerivateAssignmentFilterTypesSpecificMarket
            DerivateAssignmentFilterTypesSpecificMarket
            : [];
    }

    private getAssignmentFilterDataSource = (assignmentFilterTypes: EOptionState[]) => {
        let dataSource: DropdownItemProps[] = [];

        if (!assignmentFilterTypes.every((item) => this.props.assignmentTypeFilterValue.filterValues.has(item))) {
            dataSource.push(
                {
                    value: SelectAllAssignmentTypes,
                    content: <h4>{i18n.t("OPTIONS_VIEW:SELECT_ALL_ASGN_TYPES")}</h4>
                }
            );
        }
        if (this.props.loadedPSL && this.props.loadedPSL.cnr.cnr === PropertiesKey.BasicMarketCnrKey) {
            dataSource.push({
                key: SelectEmptyAssignmentTypes,
                value: EOptionState.NotAvailable,
                text: i18n.t("OPTIONS_VIEW:EMPTY_DERIVATE_ASSIGNMENTS"),
                content: <h4>{i18n.t("OPTIONS_VIEW:EMPTY_DERIVATE_ASSIGNMENTS")}</h4>,
            });
        }
        if (this.props.loadedPSL && this.props.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey) {
            dataSource.push({
                key: SelectOnlyMissingPDiPAssignments,
                value: SelectOnlyMissingPDiPAssignments,
                text: i18n.t("OPTIONS_VIEW:SHOW_ONLY_MISSING_ASGN"),
                content: <h4 className={'color--red'}>{i18n.t("OPTIONS_VIEW:SHOW_ONLY_MISSING_ASGN")}</h4>,
                className: 'color--red'
            });
        }

        dataSource.push(...DerivateUtils.getDerivateRenderDataSource(assignmentFilterTypes));

        return dataSource;
    }

    render() {
        const {handleSpecificTypeFilterChange, switchHeaderMode} = this.props;
        const assignmentFilterTypes = this.getLoadedPSLValidAssignmentTypes();

        return (
            <Sidebar.Pushable as='div' className='action-header-container'>
                {handleSpecificTypeFilterChange !== undefined &&
                    <Sidebar
                        as='div'
                        animation='overlay'
                        visible={this.state.isSpecificFilterVisible}
                        direction='right'
                        className='action-header-sidebar'
                    >
                        <Menu className={'action-header-filter margin--0-important'}>
                            <Menu.Item
                                style={{color: 'white'}}
                                onClick={() => this.setState({isSpecificFilterVisible: false})}
                            >
                                <Icon name='filter' style={{margin: 0}} />
                                <Icon name='angle right' />
                                {i18n.t('SM_OPTIONS_VIEW:SPECIFIC_FILTER')}
                            </Menu.Item>
                            <Menu.Item className={'action-header-dropdown'}>
                                <Dropdown
                                    id={"specific-filter"}
                                    placeholder={i18n.t('SM_OPTIONS_VIEW:SPECIFIC_FILTER_SELECT')}
                                    fluid={true}
                                    selection={true}
                                    options={this.getSpecificFilterDataSource()}
                                    value={this.props.specificFilterValue}
                                    // @ts-ignore
                                    onChange={(e, v) => this.props.handleSpecificTypeFilterChange(v.value)}
                                    closeOnChange={true}
                                    className={"font-weight--bold"}
                                />
                            </Menu.Item>
                        </Menu>
                    </Sidebar>
                }
                <Sidebar
                    as='div'
                    animation='overlay'
                    visible={this.state.isAssignmentFilterVisible}
                    direction='right'
                    className='action-header-sidebar'
                >
                    <Menu className={'action-header-filter margin--0-important'}>
                        <Menu.Item
                            style={{color: 'white'}}
                            onClick={() => this.setState({isAssignmentFilterVisible: false})}
                        >
                            <Icon name='filter' style={{margin: 0}} />
                            <Icon name='car' />
                            <Icon name='angle right' />
                            {i18n.t('OPTIONS_VIEW:ASSIGNMENT_FILTER')}
                        </Menu.Item>
                        <Menu.Item className={'action-header-dropdown width--min-content'}>
                            <Dropdown
                                id={'assignment-filter'}
                                style={this.props.assignmentTypeFilterValue.filterValues.size > 7 ? {padding: '0px 20px 0px 5px'} : {}}
                                placeholder={i18n.t('OPTIONS_VIEW:ASSIGNMENT_FILTER_SELECT')}
                                fluid={true}
                                selection={true}
                                clearable={true}
                                multiple={true}
                                options={this.getAssignmentFilterDataSource(assignmentFilterTypes)}
                                value={this.props.assignmentTypeFilterValue.missingPDiPAsgn === true ?
                                    [SelectOnlyMissingPDiPAssignments] : Array.from(this.props.assignmentTypeFilterValue.filterValues)}
                                onChange={(e, v) => {
                                    const newValues = v.value ? new Set(v.value as number[]) : new Set<number>();

                                    if (newValues.has(SelectAllAssignmentTypes)) {
                                        this.props.handleAssignmentTypeFilterChange(new Set(assignmentFilterTypes));
                                    } else if (newValues.has(SelectOnlyMissingPDiPAssignments) && this.props.assignmentTypeFilterValue.missingPDiPAsgn !== true) {
                                        this.props.handleAssignmentTypeFilterChange(new Set(), true);
                                    } else {
                                        newValues.delete(SelectOnlyMissingPDiPAssignments);
                                        this.props.handleAssignmentTypeFilterChange(newValues);
                                    }
                                }}
                                renderLabel={this.renderAssignmentFilterLabel}
                                closeOnChange={false}
                            />
                        </Menu.Item>
                    </Menu>
                </Sidebar>
                <Sidebar.Pusher>
                    <div style={{display: 'flex', justifyContent: 'space-between'}} >
                        {switchHeaderMode ?
                            <AdvancedModeHeader {...this.props} /> :
                            <StandardModeHeader  {...this.props} />
                        }
                        <div className='display--flex'>
                            <Button
                                style={{
                                    display: 'flex',
                                    padding: '10px 9px 10px 3px',
                                    background: this.props.assignmentTypeFilterValue.filterValues.size > 0 || this.props.assignmentTypeFilterValue.missingPDiPAsgn === true
                                        ? '#950014' : '#313639'
                                }}
                                onClick={() => this.setState({isAssignmentFilterVisible: true})}
                            >
                                <Icon name='angle left' />
                                <Icon name='car' />
                                <Icon name='filter' />
                            </Button>
                            {handleSpecificTypeFilterChange !== undefined &&
                                <Button
                                    style={{
                                        padding: '10px 9px 10px 3px',
                                        background: this.props.specificFilterValue
                                            && this.props.specificFilterValue.length > 0 ? '#950014' : '#313639'
                                    }}
                                    onClick={() => this.setState({isSpecificFilterVisible: true})}
                                >
                                    <Icon name='angle left' />
                                    <Icon name='filter' />
                                </Button>
                            }
                            {this.props.isNewGridTable &&
                                <div className="options-header-new-grid-indicator padding--t-10 padding--b-10 padding--l-20 font-size--smallest color--white background--blue-dark">
                                    <Button
                                        style={{
                                            display: 'flex',
                                            padding: '10px',
                                            background: '#313639'
                                        }}
                                        onClick={() => this.props.onResetFilters && this.props.onResetFilters()}
                                    >
                                         <Icon name='remove' />
                                        <Icon name='filter' />
                                    </Button>
                                </div>
                            }
                        </div>

                    </div>
                </Sidebar.Pusher>
            </Sidebar.Pushable >
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/OptionsView/OptionsHeader/OptionsHeader.tsx